import './style.scss';

const ButtonUI = ({ label = '', onClick = () => {}, className = '', disabled = false, type = "button", btnRef = null }) => {
    return <button ref={btnRef} disabled={disabled} type={type} className={`buttonUI ${className}`} onClick={onClick}>{label}</button>;
};

export default ButtonUI;
